document.addEventListener('DOMContentLoaded', () => {
  const titles = document.querySelectorAll('.faqs-title');
  titles.forEach(title => {
    title.addEventListener('click', function () {
      document.querySelectorAll('.open').forEach(openItem => {
        if (openItem !== this) {
          openItem.classList.remove('open');
          const content = openItem.nextElementSibling;
          if (content) {
            content.style.maxHeight = null;
          }
        }
      });
      this.classList.toggle('open');
      const content = this.nextElementSibling;
      if (content) {
        if (this.classList.contains('open')) {
          content.style.maxHeight = content.scrollHeight + 'px';
        } else {
          content.style.maxHeight = null;
        }
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {

    // Thumbnails slider
    const thumbSwiper = new Swiper('.thumb-swiper', {
      spaceBetween: 4,
      slidesPerView: 7,
      wrapperClass: 'thumb-wrapper',
      slideClass: 'thumb-media',
      freeMode: true,
      slideToClickedSlide: true,
      watchSlidesProgress: true,
    });

    // Main image slider with thumbs control
    const mainSwiper = new Swiper('.main-swiper', {
      slidesPerView: 1,
      spaceBetween: 0,
      wrapperClass: 'main-wrapper',
      slideClass: 'main-media',
      pagination: {
        el: '.swiper-pagination-main',
        type: 'progressbar',
      },
      navigation: {
           nextEl: '.swiper-arrow-right',
           prevEl: '.swiper-arrow-left',
      },
      thumbs: {
        swiper: thumbSwiper,
      },
    });
  // ────────────────────────────────────────────────
  // Pure JS lightbox (replaces Magnific Popup)
  // Works on both mobile & desktop
  // ────────────────────────────────────────────────
  const triggers = document.querySelectorAll('.image-popup-vertical-fit');
  if (triggers.length === 0) return;
  // Create lightbox container once
  const lightbox = document.createElement('div');
  lightbox.className = 'lightbox';
  lightbox.innerHTML = `
    <span class="close-btn">&times;</span>
    <span class="prev">&lsaquo;</span>
    <span class="next">&rsaquo;</span>
    <div class="counter">1 / 1</div>
  `;
  document.body.appendChild(lightbox);
  const imgWrapper = document.createElement('div');
  const img = document.createElement('img');
  imgWrapper.appendChild(img);
  lightbox.insertBefore(imgWrapper, lightbox.querySelector('.close-btn'));
  let currentIndex = 0;
  const images = [];
  // Collect all large image URLs
  triggers.forEach((trigger, index) => {
    const largeSrc = trigger.getAttribute('href') || trigger.querySelector('img')?.src;
    if (!largeSrc) return;
    images.push(largeSrc);
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      currentIndex = index;
      openLightbox();
    });
  });
  function openLightbox() {
    if (images.length === 0) return;
    updateImage();
    lightbox.classList.add('active');
    document.body.style.overflow = 'hidden';

    // Double-click = zoom toggle
    img.addEventListener('dblclick', toggleZoom, { once: true });
  }
  function updateImage() {
    img.src = images[currentIndex];
    img.alt = `Product image ${currentIndex + 1} of ${images.length}`;
    document.querySelector('.counter').textContent = `${currentIndex + 1} / ${images.length}`;

    // Reset zoom state
    lightbox.classList.remove('zoom-in');
    img.style.transform = 'scale(1)';
  }
  function toggleZoom() {
    lightbox.classList.toggle('zoom-in');
  }
  function nextImage() {
    currentIndex = (currentIndex + 1) % images.length;
    updateImage();
  }
  function prevImage() {
    currentIndex = (currentIndex - 1 + images.length) % images.length;
    updateImage();
  }
  // ────────────────────────────────────────────────
  // Event listeners for lightbox
  // ────────────────────────────────────────────────
  lightbox.querySelector('.close-btn').addEventListener('click', closeLightbox);
  lightbox.querySelector('.next').addEventListener('click', nextImage);
  lightbox.querySelector('.prev').addEventListener('click', prevImage);
  // Click outside image → close
  lightbox.addEventListener('click', (e) => {
    if (e.target === lightbox || e.target === imgWrapper) {
      closeLightbox();
    }
  });
  // Keyboard support
  document.addEventListener('keydown', (e) => {
    if (!lightbox.classList.contains('active')) return;
    switch (e.key) {
      case 'Escape':
        closeLightbox();
        break;
      case 'ArrowRight':
        nextImage();
        break;
      case 'ArrowLeft':
        prevImage();
        break;
    }
  });
  function closeLightbox() {
    lightbox.classList.remove('active');
    document.body.style.overflow = '';
    img.src = ''; // clear to save memory
    lightbox.classList.remove('zoom-in');
  }
});

window.addEventListener("load", () => {
    gsap.registerPlugin(ScrollTrigger);

    const prefersReduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    const sections = document.querySelectorAll(".shopify-section");

    if (prefersReduced) {
      gsap.set("[gsap-fadin-anim]", { opacity: 1, y: 0 });
      return;
    }

    sections.forEach((section) => {
      const items = section.querySelectorAll("[gsap-fadin-anim]");

      if (!items.length) return;
      gsap.set(items, { opacity: 0, y: 60 });

      ScrollTrigger.batch(items, {
        start: "top 90%",
        once: true,

        onEnter: (batch) => {
          gsap.to(batch, {
            opacity: 1,
            y: 0,
            duration: 0.5,
            ease: "power2.out",
            stagger: 0.3,
            overwrite: true,
          });
        },
      });
    });
    ScrollTrigger.refresh(true);
});

let lastScrollTop = 0;

document.addEventListener("scroll", function () {
  const elements = document.querySelectorAll(".shopify-section--header");
  if (!elements.length) return;
  const scrollTop = window.scrollY;
  const docHeight = document.documentElement.scrollHeight - window.innerHeight;
  const scrollPercent = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
  elements.forEach(el => {
    if (scrollPercent >= 0.5) {
      el.classList.add("is-active");
      if (scrollTop < lastScrollTop) {
        el.classList.remove("trueform");
      } else {
        el.classList.add("trueform");
      }
    } else {
      el.classList.remove("is-active");
      el.classList.remove("trueform");
    }
  });
  lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; 
});

window.addEventListener("load", function () {
  const event = new Event("scroll");
  document.dispatchEvent(event);
});



document.addEventListener("DOMContentLoaded", function(){

  const trigger = document.querySelector(".jdgm-preview-badge");
  const target = document.querySelector(".jdgm-rev-widg");

  if(trigger && target){
    trigger.addEventListener("click", function(e){
      e.preventDefault();

      target.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    });
  }

});